"use strict";
/*
 * Created on 21. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var FlagSet_1 = require("../../../core/model/FlagSet");

var RequiresRecalculation_1 = require("../../../release/model/alerts/RequiresRecalculation");

var FinalProductPriceValidationKey_1 = require("../../../release/model/FinalProductPriceValidationKey");
/**
 * VAT changed event.
 * @author Radek Beran
 */


var VATChanged =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(VATChanged, _EntityEventFlag_1$En);

  function VATChanged() {
    _classCallCheck(this, VATChanged);

    return _possibleConstructorReturn(this, _getPrototypeOf(VATChanged).apply(this, arguments));
  }

  _createClass(VATChanged, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return VATChanged;
}(EntityEventFlag_1.EntityEventFlag);

exports.VATChanged = VATChanged;
VATChanged.TAG = EntityEventFlag_1.EntityEventFlag.register(VATChanged);
VATChanged.INSTANCE = new VATChanged();
VATChanged.MESSAGE = new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.VATChanged, immutable_1.List.of(), null, null, FlagSet_1.FlagSet.of(ValidationResultFlag_1.ValidationResultFlag, RequiresRecalculation_1.RequiresRecalculation.INSTANCE));